module.exports = __webpack_public_path__ + "static/doodles-95ba1038b24e08694b7f6b851ddd5dd5.png";